<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jMTeXI/tc-custom/9781646564828.jpg?1723403769599" alt="This image is the cover for the book Dance Until the World Ends"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dance Until the World Ends
      </h1>
      <p class="bookDescription body article font2">
        <p>Lina and Arabel are just a couple of gals on the lower rungs of society's ladder. Born into a culture with rigid caste system, all they want to do is find the next good party. Never in their wildest dreams would they suspect the survival of their island colony might rest on their shoulders. But things come to a head when the ever seething rebellion pushes the two women into the spotlight and into danger's path.<br/><br/>With their own colony no longer safe, these best friends find themselves on the run, fleeing with only the clothes on their backs. Their journey into the unknown leads them to discover strange new lands, never before visited, some with even stranger inhabitants than their own. Will these newfound acquaintances prove to be friend or foe, or simply another temptation from the path?<br/><br/>Follow Lina and Arabel on a hero's adventure of epic proportions at the far distant edge of humanity's future. Sailing over the clouds, risking everything to do what is right for their people and their colony.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Davina Lee
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f95020b